function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Object, inputValue, inputWidth) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'autoresizing-input-input-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": {
            readonly: $attr(`disabled`),
            placeholder: $attr(`placeholder`),
          },
          "props": Object.assign({
              type: `text`,
              value: inputValue,
            },
            $attr(`max-length`) ? {
              maxLength: $attr(`max-length`)
            } : {}
          ),
          "style": Object.assign({
            width: `${inputWidth}px`,
          }, $attr(`input-style-overrides`)),
          "on": {
            input: $helpers.updatedInput,
            focus: $helpers.handleFocus,
            blur: $helpers.handleBlur,
            keypress: $helpers.propagateEvent,
            change: $helpers.propagateEvent,
          },
          "hook": {
            insert: vnode => $helpers.inserted(vnode),
            postpatch: (oldVnode, vnode) => $helpers.inserted(vnode),
          },
          "class": Object.assign({}, {
            [`autoresizing-input-theme-${$attr(`theme`)}`]: true,
          }, {
            'remove-chrome-form-style': true
          }),
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined, "inputWidth" in locals ? locals.inputWidth : typeof inputWidth !== "undefined" ? inputWidth : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;